module.exports = __webpack_public_path__ + "static/media/Image-5_1645456833438.d190803e.jpg";